import { MaxNumbersOfSuggestions } from 'constants/suggestion';
import { useMemo } from 'react';
import useUserRecentSearchSuggestions from './useUserRecentSearchSuggestions';

export const useGetRecentOrTrending = ({
    showOnlyFilterSuggestions,
    isInputEmpty,

    isRecentAllowed,
    isTrendingAllowed,
}: {
    showOnlyFilterSuggestions: boolean;
    isInputEmpty: boolean;

    isRecentAllowed: boolean;
    isTrendingAllowed: boolean;
}) => {
    const recent = useUserRecentSearchSuggestions(showOnlyFilterSuggestions);

    const hasRecent = isRecentAllowed && recent.length > 0;

    const isRecentOrTrendingVisible =
        isInputEmpty && (hasRecent || isTrendingAllowed);

    const recentTrending = useMemo(
        () => recent.slice(0, MaxNumbersOfSuggestions),
        [recent],
    );

    return { isRecentOrTrendingVisible, recentTrending };
};
